module.exports = __webpack_public_path__ + "img/1.209f0f0e.png";